{
  "SEARCH": {
    "TABS": {
      "ALL": "Visi",
      "CONTACTS": "Kontaktpersonas",
      "CONVERSATIONS": "Sarunas",
      "MESSAGES": "Ziņojumi"
    },
    "SECTION": {
      "CONTACTS": "Kontaktpersonas",
      "CONVERSATIONS": "Sarunas",
      "MESSAGES": "Ziņojumi"
    },
    "VIEW_MORE": "Skatīt vairāk",
    "LOAD_MORE": "Ielādēt vairāk",
    "SEARCHING_DATA": "Meklēšana",
    "LOADING_DATA": "Notiek ielāde",
    "EMPTY_STATE": "Vaicājumam '{query}' nav atrasts neviens {item} vienums",
    "EMPTY_STATE_FULL": "Vaicājumam '{query}' nav atrasts neviens rezultāts",
    "PLACEHOLDER_KEYBINDING": "/ fokusēt",
    "INPUT_PLACEHOLDER": "Ievadiet 3, vai vairāk, rakstzīmes, lai meklētu",
    "RECENT_MESSAGES": "Mani nesen nosūtītie ziņojumi",
    "EMPTY_STATE_DEFAULT": "Lai iegūtu labākus meklēšanas rezultātus, meklējiet pēc sarunas Id, e-pasta, tālruņa numura vai ziņām. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Lasīt vairāk",
    "WROTE": "rakstīja:",
    "FROM": "no",
    "EMAIL": "e-pasts",
    "EMAIL_SUBJECT": "tēma"
  }
}
